import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { ProofCenter } from '../../../../models/ProofCenter';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-proof-centers-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent
  ],
  templateUrl: './proof-center-configuration.component.html',
  styleUrl: './proof-center-configuration.component.css'
})
export class ProofCentersConfigurationComponent {
  tableColumns: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Dirección', active: true, type: 'text', key: 'address', sort: true },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'nullable' },
    { name: 'address', type: 'text', label: 'Dirección', validations: 'nullable' },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'nullable' },
    { name: 'address', type: 'text', label: 'Dirección', validations: 'nullable' },
  ];

  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'centro de Examen',
    createButtonTitle: 'Nuevo Centro de Examen',
    cols: 2,
    createApiSlug: '/config/proof-center/store',
    formTitle: 'Crear Centro de Examen',
    formButtonTitle: 'Crear',
    width: '3xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'proofCenter',
        createButtonTitle: '',
        cols: 2,
        originalUpdateApiSlug: '/config/proof-center/update/{{id}}',
        createApiSlug: '',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '3xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿Desea eliminar el centro de examen?',
      deleteRowOnResponse: true,
      actionSlug: '/config/proof-center/delete/{{id}}',
    }
  ];

  table: GenericTable<Paginator<ProofCenter>> = {
    columns: this.tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/proof-center/index',
    paginate: true,
    name: 'centros de Examen',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|address', operator: 'like', placeholder: 'Nombre o dirección' },
  ];

  genericCRUD: GenericCRUD<Paginator<ProofCenter>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
